import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserInfoLink } from "../../types/shared-module-types";

type UIState = {
  isLeftNavBarFixed: boolean;
  activeTab: string | null;
  todayHours: number;
  weeklyHours: number;
  scheduledHours: number;
  isLoadingInfoUser: boolean;
  photo: string | null | undefined;
  links: UserInfoLink[];
  entryReminder: boolean;
  asuitePermissions: string[];
  // TODO: should be removed once ASuite becomes deprecated
  // remove "modulePermissions" from this endpoint api/users/Users/user-details/:mail
  modulePermissions: object;
  userRolesProductsModule: string[];
  isLoadingRolesProductsModule: boolean;
};

const initialState: UIState = {
  isLeftNavBarFixed: localStorage.getItem("isLeftNavBarFixed") === "true",
  activeTab: null,
  todayHours: 0,
  weeklyHours: 0,
  scheduledHours: 8,
  isLoadingInfoUser: true,
  photo: undefined,
  links: [],
  entryReminder: true,
  asuitePermissions: [],
  modulePermissions: {},
  userRolesProductsModule: [],
  isLoadingRolesProductsModule: true,
};

export const uiSharedSlice = createSlice({
  name: "uiShared",
  initialState,
  reducers: {
    // Remember Redux Toolkit allows us to write "mutating" logic in reducers.
    toggleLeftNavBarFixed: (state) => {
      state.isLeftNavBarFixed = !state.isLeftNavBarFixed;
      localStorage.setItem(
        "isLeftNavBarFixed",
        state.isLeftNavBarFixed.toString()
      );
    },
    forceCollapseLeftNavBarFixed: (state) => {
      state.isLeftNavBarFixed = false;
      localStorage.setItem("isLeftNavBarFixed", "false");
    },
    setActiveTab: (state, action: PayloadAction<string>) => {
      state.activeTab = action.payload;
    },
    setHours: (
      state,
      action: PayloadAction<{
        totalHoursDay: number;
        totalHoursWeek: number;
        scheduledHours: number;
      }>
    ) => {
      state.todayHours = action.payload.totalHoursDay;
      state.weeklyHours = action.payload.totalHoursWeek;
      state.scheduledHours = action.payload.scheduledHours;
    },
    setInfoUser: (
      state,
      action: PayloadAction<{
        photo: string;
        links: UserInfoLink[];
        entryReminder: boolean;
        asuitePermissions: string[];
        modulePermissions: object;
      }>
    ) => {
      state.photo = action.payload.photo;
      state.entryReminder = action.payload.entryReminder;
      state.asuitePermissions = action.payload.asuitePermissions;
      state.modulePermissions = action.payload.modulePermissions;
      let links = action.payload.links;
      if (links) {
        state.links = links.sort((a: UserInfoLink, b: UserInfoLink) =>
          a.title.localeCompare(b.title)
        );
      }
      state.isLoadingInfoUser = false;
    },
    setEntryReminder: (state, action) => {
      state.entryReminder = action.payload;
    },
    setRolesByModule: (state, action: PayloadAction<any>) => {
      state.userRolesProductsModule = action.payload.productsRoles;
      state.isLoadingRolesProductsModule = false;
    },
    clear: (state) => {
      state.todayHours = 0;
      state.weeklyHours = 0;
      state.scheduledHours = 8;
      state.isLoadingInfoUser = true;
      state.photo = undefined;
      state.links = [];
      state.entryReminder = true;
      state.asuitePermissions = [];
      state.modulePermissions = {};
      state.userRolesProductsModule = [];
      state.isLoadingRolesProductsModule = true;
    },
  },
});

export const {
  toggleLeftNavBarFixed,
  forceCollapseLeftNavBarFixed,
  setActiveTab,
  setHours,
  setInfoUser,
  setEntryReminder,
  setRolesByModule,
  clear,
} = uiSharedSlice.actions;

// Selectors
export const actualUIState = ({ uiShared }: { uiShared: UIState }) => ({
  isLeftNavBarFixed: uiShared.isLeftNavBarFixed,
  activeTab: uiShared.activeTab,
  todayHours: uiShared.todayHours,
  weeklyHours: uiShared.weeklyHours,
  scheduledHours: uiShared.scheduledHours,
  photo: uiShared.photo,
  links: uiShared.links,
  isLoadingInfoUser: uiShared.isLoadingInfoUser,
  entryReminder: uiShared.entryReminder,
  asuitePermissions: uiShared.asuitePermissions,
  modulePermissions: uiShared.modulePermissions,
  userRolesProductsModule: uiShared.userRolesProductsModule,
  isLoadingRolesProductsModule: uiShared.isLoadingRolesProductsModule,
});

export default uiSharedSlice.reducer;
